export default __webpack_public_path__ + "static/media/recurly-logo.8e81722f.svg";